import { Buffer } from "buffer"
import scrollIntoView from "scroll-into-view-if-needed"
import qs from "qs"
import cookie from "cookie"
import cloneDeep from "lodash/cloneDeep"
import transform from "lodash/transform"
import merge from "lodash/merge"

export function splitNames(name: string | undefined) {
    if (name === undefined) {
        return {
            first: "",
            last: "",
        }
    }
    // NOTE: If only a single word/name supplied, it will be returned as the 'last' name.
    // This is because the data will be sent to Zoho to create a lead, and the last name
    // is mandatory for lead creation.
    return {
        first: name.substring(0, name.indexOf(" ")),
        last: name.substring(name.indexOf(" ") + 1),
    }
}

export function encodeBase64(data: string) {
    return Buffer.from(data).toString("base64")
}

export function scrollToId(id: string) {
    const node = document.getElementById(id)
    if (node) {
        scrollIntoView(node, { behavior: "smooth", scrollMode: "if-needed", block: "start" })
    }
}

export function filterQueryString(queryString: string) {
    const queryObj = qs.parse(queryString, { ignoreQueryPrefix: true })
    return filterMarketingValues(queryObj)
}

export function filterCookies(cookieString: string) {
    const cookieObj = cookie.parse(cookieString)
    return filterMarketingValues(cookieObj)
}

export function filterMarketingValues(obj: { [key: string]: any }) {
    const cloneObj = cloneDeep(obj)
    const lowerObj = transform(cloneObj, function (result: { [key: string]: any }, val, key) {
        result[key.toLowerCase()] = val
    })
    const marketingValArray = [
        "utm_campaign",
        "utm_content",
        "utm_term",
        "utm_source",
        "utm_medium",
        "gclid",
        "fbclid",
        "utm_referral",
    ]
    if (lowerObj !== {}) {
        Object.keys(lowerObj)
            .filter((key) => !marketingValArray.includes(key))
            .forEach((key) => delete lowerObj[key])
    }
    return lowerObj
}

export function mergeMarketingObjects(queryObj: Record<string, unknown>, cookieObj: Record<string, unknown>) {
    return merge(cookieObj, queryObj)
}

export function decodeFormData(value: string) {
    const urlParams = new URLSearchParams(value)
    const formDataEncoded = urlParams.get("bpm_fd")
    if (formDataEncoded === null) {
        return {}
    }
    const rawFormData = Buffer.from(formDataEncoded, "base64").toString()
    try {
        return JSON.parse(rawFormData)
    } catch {
        return {}
    }
}

export function generateSourceName(source: string, location: string) {
    if (location === "sia") {
        if (source === "signup") {
            return "SIA Sign up"
        } else {
            return "SIA Demo"
        }
    }
    if (location === "web") {
        if (source === "signup") {
            return "BPM Website Sign up"
        } else {
            return "BPM Website Demo"
        }
    }
    return undefined
}
